module.exports = __webpack_public_path__ + "img/STRENGTH.0d6599c6.png";